export const monthlyRewardsConstants = {
    GET_MONTHLY_REWARDS_REQUEST: 'GET_MONTHLY_REWARDS_REQUEST',
    GET_MONTHLY_REWARDS_SUCCESS: 'GET_MONTHLY_REWARDS_SUCCESS',
    GET_MONTHLY_REWARDS_ERROR: 'GET_MONTHLY_REWARDS_ERROR',

    PUT_MONTHLY_REWARDS_REQUEST: 'PUT_MONTHLY_REWARDS_REQUEST',
    PUT_MONTHLY_REWARDS_SUCCESS: 'PUT_MONTHLY_REWARDS_SUCCESS',
    PUT_MONTHLY_REWARDS_ERROR: 'PUT_MONTHLY_REWARDS_ERROR'
};
